export default [
  {
    path: '/ai_agent',
    name: 'AiAgentView',
    component: () =>
      import(
        /* webpackChunkName: "ai-agent" */ '@/views/AiAgent/AiAgentView.vue'
      ),
    meta: {
      title: 'AI Agent',
      group: 'adminSettings',
      requiresRole: ['SUPER_ADMIN', 'ADMIN'],
    },
  },
]
